module.exports = __webpack_public_path__ + "static/bg_mobile-bd5324847f92da6a96d207c69ca0ad9d.mp4";